document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("testimonial-widget");
  if (!container) return;

  function normalizeTimeString(timeStr) {
    const hourMatch = timeStr.match(/(\d+)\s*hour/);
    const hourCount = hourMatch ? parseInt(hourMatch[1], 10) : 0;

    if (hourCount < 24) {
      return `${hourCount} hour${hourCount === 1 ? "" : "s"} ago`;
    } else {
      const dayCount = Math.floor(hourCount / 24);
      return `${dayCount} day${dayCount === 1 ? "" : "s"} ago`;
    }
  }

  function generateTrustpilotStars() {
    return `
    <span class="tp-star">★</span>
    <span class="tp-star">★</span>
    <span class="tp-star">★</span>
    <span class="tp-star">★</span>
    <span class="tp-star">★</span>
  `;
  }

  const reviewPool = [
    {
      author: "Byron King",
      time: "13 hours ago",
      title: "Exactly what I wanted",
      message: "Sturdy yet stylish, really stands out.",
    },
    {
      author: "Dale Crane",
      time: "12 hours ago",
      title: "True work of art",
      message:
        "Sturdy yet sophisticated, perfect for men who love fine jewelry.",
    },
    {
      author: "Emilia Wood",
      time: "29 hours ago",
      title: "Boyfriend loves it",
      message: "Bold and subtle, perfect accessory for the night.",
    },
    {
      author: "Oscar Deraldo",
      time: "50 hours ago",
      title: "Totally worth it",
      message:
        "I bought a necklace and bracelet combo from Dernholt, and they make such a cool statement together! Just a tad heavier than I expected, but I still love them.",
    },
    {
      author: "Roosevelt Pittman",
      time: "72 hours ago",
      title: "Golden touch",
      message: "Fantastic shine, catches the eye. Clasp could be stronger.",
    },
    {
      author: "Carl D. Perez",
      time: "12 hours ago",
      title: "Good support",
      message: "Support answered quickly and helped out. Products are ok.",
    },
    {
      author: "William Gray",
      time: "14 hours ago",
      title: "Eye-catching gold chain",
      message: "Took longer than expected, but looks truly luxurious.",
    },
    {
      author: "Leroy Smith",
      time: "2 hours ago",
      title: "Love my necklace",
      message: "Hoping they add more designs. Want more options!",
    },
    {
      author: "Gerard P. Hamm",
      time: "4 hours ago",
      title: "Beyond expectations",
      message: "Gold body chain is a statement piece and versatile too.",
    },
    {
      author: "Jonas Bauer",
      time: "18 hours ago",
      title: "Must-Have for me",
      message: "Minimal yet bold Nordic design. Loving my silver necklace!",
    },
    {
      author: "Taylor",
      time: "10 hours ago",
      title: "Robust and refined",
      message: "Exactly what I wanted in a designed chain.",
    },
    {
      author: "Barry Wyant",
      time: "12 hours ago",
      title: "Bracelet and body chain",
      message:
        "I ordered a bracelet and body chain, and they're beyond amazing! Luxurious metal, top-notch craftsmanship.",
    },
    {
      author: "Hudson Brooks",
      time: "52 hours ago",
      title: "Pharaoh Cat necklace",
      message: "Perfect match for cat lovers like me. Loved it.",
    },
    {
      author: "William Tellez",
      time: "15 hours ago",
      title: "Durable pendant necklace",
      message: "Been wearing it for weeks, still looks brand new!",
    },
    {
      author: "Anthony Zook",
      time: "34 hours ago",
      title: "Stunning Craftsmanship",
      message: "Super impressed with the body chain quality and unique design.",
    },
    {
      author: "Ono Yoko",
      time: "3 hours ago",
      title: "Yo this pearl chain is legit FIRE",
      message: "Didn't know I could rock pearls but I get compliments all the time now.",
    },
    {
      author: "John Casanova",
      time: "18 hours ago",
      title: "Great value",
      message: "Feels like high-end jewelry, but the price is reasonable.",
    },
    {
      author: "Thomas Glasscock",
      time: "39 hours ago",
      title: "Solid bracelet",
      message: "Very solid and well-made, but shipping took two weeks.",
    },
    {
      author: "Keith Johnson",
      time: "6 hours ago",
      title: "Nice Bracelet",
      message:
        "Design is great but clasp could be better. Hope it holds up over time.",
    },
    {
      author: "Michael Freud",
      time: "38 hours ago",
      title: "Impressive but pricey",
      message:
        "Love their masculine designs but wish the prices were lower. Still, worth it for the quality.",
    },
    {
      author: "Frederica",
      time: "65 hours ago",
      title: "Bought for boyfriend",
      message: "He liked it a lot, came with beautiful package too.",
    },
    {
      author: "Liam Williams",
      time: "68 hours ago",
      title: "Craftsmanship and design",
      message:
        "Dernholt Stockholm makes excellent jewelry. Elegant designs that are just perfect. I'm so happy with the quality.",
    },
    {
      author: "Javier McLean",
      time: "50 hours ago",
      title: "Second purchase coming!",
      message:
        "After my first order, I knew I'd come back. Go-to for men’s jewelry now.",
    },
    {
      author: "Craig Alvarez",
      time: "5 hours ago",
      title: "Nice Jewelry, slow shipping",
      message:
        "Bracelet looks amazing, great fit. Shipping was delayed but support helped.",
    },
    {
      author: "Sean Morgan",
      time: "58 hours ago",
      title: "Stylish but Sizing Off",
      message: "Size smaller than expected, but extension chains helped.",
    },
    {
      author: "Carey Wiles",
      time: "48 hours ago",
      title: "Unique and Stylish",
      message: "Perfect for adding edgy but classy touch to outfits.",
    },
    {
      author: "Wayne Tran",
      time: "33 hours ago",
      title: "Go-to for men's jewelry",
      message:
        "Bold yet elegant. Perfect for everyday wear or special occasions.",
    },
    {
      author: "Kathleen Davis",
      time: "12 hours ago",
      title: "Boyfriend loved it",
      message: "Got a necklace for my boyfriend and he loves it!",
    },
    {
      author: "Joshep Joy",
      time: "62 hours ago",
      title: "My new necklace is stunning",
      message:
        "It feels so modern and adds a sexy touch to my look. I love how it makes even simple outfits look great.",
    },
    {
      author: "Christian Ziegler",
      time: "31 hours ago",
      title: "Fast Shipping",
      message: "Used Express service, package came in a few days!",
    },
  ];

  // 排序
  const sorted = reviewPool
    .map((review, index) => {
      const hourMatch = review.time.match(/(\d+)\s*hour/);
      const hours = hourMatch ? parseInt(hourMatch[1], 10) : 9999;
      return { ...review, hours };
    })
    .sort((a, b) => a.hours - b.hours); // 新评论在前

  const html = sorted
    .map((review, i) => {
      const displayTime = normalizeTimeString(review.time);
      return `
  <div class="testimonial-card">
  <div class="testimonial-stars">
  <span class="tp-star">★</span>
  <span class="tp-star">★</span>
  <span class="tp-star">★</span>
  <span class="tp-star">★</span>
  <span class="tp-star">★</span>
</div>

  <div class="testimonial-meta">${review.author}, ${displayTime}</div>
  <div class="testimonial-title">${review.title}</div>
  <div class="testimonial-message" data-full="${review.message}">
    ${review.message}
  </div>
  
  <span class="testimonial-readmore" data-title="${review.title}" data-message="${review.message}">Read more</span>

</div>

`;
    })
    .join("");

  container.innerHTML = html;

  // Modal
  const modalOverlay = document.createElement("div");
  modalOverlay.className = "testimonial-modal-overlay";
  modalOverlay.innerHTML = `
    <div class="testimonial-modal">
      <span class="testimonial-modal-close">&times;</span>
      <div class="testimonial-modal-title"></div>
      <div class="testimonial-modal-content"></div>
    </div>
  `;
  document.body.appendChild(modalOverlay);

  const modal = modalOverlay.querySelector(".testimonial-modal");
  const modalTitle = modal.querySelector(".testimonial-modal-title");
  const modalContent = modal.querySelector(".testimonial-modal-content");
  const closeModal = modal.querySelector(".testimonial-modal-close");

  // container.addEventListener("click", function (e) {
  //   if (e.target.classList.contains("testimonial-readmore")) {
  //     const idx = e.target.getAttribute("data-index");
  //     const review = sorted[idx];
  //     modalTitle.textContent = review.title;
  //     modalContent.textContent = review.message;
  //     modalOverlay.style.display = "flex";
  //   }
  // });
  // 更新 Read more 点击事件
  container.addEventListener("click", function (e) {
    if (e.target.classList.contains("testimonial-readmore")) {
      const title = e.target.getAttribute("data-title");
      const message = e.target.getAttribute("data-message");
      modalTitle.textContent = title;  // 更新弹窗标题
      modalContent.textContent = message;  // 更新弹窗内容
      modalOverlay.style.display = "flex";  // 显示弹窗
    }
  });

  closeModal.addEventListener("click", () => {
    modalOverlay.style.display = "none";  // 关闭弹窗
  });

  modalOverlay.addEventListener("click", (e) => {
    if (e.target === modalOverlay) {
      modalOverlay.style.display = "none";  // 点击背景关闭弹窗
    }
  });
});
